/* Settings > Practitioners (docs/plans/phase1-consultation.md §7.4). Tokens only; states
   are words and shapes. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.intro {
  max-width: var(--form-max);
  margin: 0;
  font: var(--t-body);
  color: var(--graphite);
}

.id {
  font-family: var(--font-id);
  font-variant-numeric: tabular-nums;
}

.detail {
  font: var(--t-small);
  color: var(--graphite);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-3);
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding-top: var(--space-4);
  border-top: 1px solid var(--rule);
}

.sectionHeading {
  margin: 0;
  font: var(--t-heading);
}
